function pluralize(time, label) {
    if (time === 1) {
        return time + label
    }
    return time + label + 's'
}

export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time)
    if (between < 3600) {
        return pluralize(~~(between / 60), ' minute')
    } else if (between < 86400) {
        return pluralize(~~(between / 3600), ' hour')
    } else {
        return pluralize(~~(between / 86400), ' day')
    }
}

/* 数字 格式化*/
export function nFormatter(num, digits) {
    const si = [
        { value: 1E18, symbol: 'E' },
        { value: 1E15, symbol: 'P' },
        { value: 1E12, symbol: 'T' },
        { value: 1E9, symbol: 'G' },
        { value: 1E6, symbol: 'M' },
        { value: 1E3, symbol: 'k' }
    ]
    for (let i = 0; i < si.length; i++) {
        if (num >= si[i].value) {
            return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
        }
    }
    return num.toString()
}

export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * 千分位过滤
 * @param {*} num
 */
export function toThousandslsFilter(num) {
    return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * 选项过滤
 * @param {*} val  值
 * @param {*} options 选项值
 * @param {*} labelKey  选项的展示值key
 * @param {*} valueKey  选项的值key
 */
export function optionsFilter(val, options = [], labelKey = 'label', valueKey = 'value', defaultValue = '') {
    const opt = options.find(x => x[valueKey] === val)
    return opt ? opt[labelKey] : val || defaultValue
}

// 应收审核页面金额千分位过滤器
export function formatMoney(num) {
    if (num === 'null' || num === null) return '--'
    return (+num || 0).toFixed(2).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function formatPrice(num) {
    return '￥' + formatMoney(num)
}

export function formatMoneyWithZero(num) {
    if (num === 'null' || num == null) return '0.00'
    return (+num || 0).toFixed(2).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function emailMask(str) {
    // let len = str.length
    // str = "12345sssss@qq1234.com"
    if (str) {
        // console.log('this array is', str.split('@'))
        let s1 = str.split('@')[0]
        let s2 = str.split('@')[1]

        let l1 = s1.length
        let head = s1.substr(0, l1 - 3) + '*'.repeat(3)

        let l2 = s2.length
        let tail = '*'.repeat(3) + s2.substr(3, l2 - 3)
        let r = head + '@' + tail
        return r
    }
    return '--'
}
export function normalMask(str) {
    // let len = str.length
    // console.log('this str is ', str)
    if (str) {
        let len = str.length
        let count = len - 6
        if (count > 0) {
            let head = str.substr(0, 3)
            let tail = str.substr(len - 3, 3)
            let middle = "*".repeat(count)
            let r = head + middle + tail
            return r
        }
    }
    return '--'
}

export function formatSpaceText(text) {
    if (!text) {
        return '--'
    }
    return text
}
export function formatSelectSpaceText(text) {
    if (!text) {
        return '请选择'
    }
    return text
}


//  时间格式的过滤器
/**
 *
 * @param {*} type 要转成的类型的名称
 */
export function timeToYMD(value) {
    /**
     * 格式1：ymd:  2019-01-22 00:00:00  ==> 2019-01-22
     */
    if (!value) return '--'
    if (value === '--') return '--'
    let date = new Date(value)
    if (!date || !date.getFullYear) return
    let result = ''

    result = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).substr(-2)}-${('0' + date.getDate()).substr(-2)}`
    return result
}
